import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'userWithoutName'
})
export class UserWithoutNamePipe implements PipeTransform {
  transform(value: string): string {
    return value.slice(0, value.indexOf('@')).replace(/-|[.]/g, ' ');
  }
}
